import Badge from "../../../components/basicComponent/Badge";
import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import { airlineLogos } from "../../../constants/constant";
import { parseDynamicFareRules } from "../../../constants/helper";
import { useGlobalState } from "../../../services/context/AuthContext";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
type FlightDetailMainCardProps = {
  flightData: any;
  refundable?: boolean;
  flightFareRules?: string;
  isInBound?: boolean;
  isInternationalFlight: boolean;
};

const FlightDetailMainCard = ({
  flightData,
  refundable,
  flightFareRules,
  isInBound,
  isInternationalFlight,
}: FlightDetailMainCardProps) => {
  const [isActive, setIsActive] = useState(false);
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const { userInfo } = useGlobalState();
  if (!flightData) {
    return <div>No flight data available</div>;
  }
  const { fareDetails: dynamicFareRules, emtFee } =
    parseDynamicFareRules(flightFareRules);

  const currency = userInfo?.currencyCode || "AED";
  return (
    <>
      <div className="card-body collapse-content">
        <div className="fli-d-m ng-scope tr-cn-m">
          <div className="dprtBg ng-scope">
            {isInBound ? "Return" : "Depart"}
          </div>
          {flightData?.map((flight: any, index: number) => (
            <div className="row" key={index}>
              <div className=" fd-des col-md-12">
                <span className="ng-binding">
                  {flight.Origin} - {flight.Destination} |
                </span>
                <span className="ng-binding">{flight.DepartureDate}</span>
              </div>

              <div className="row">
                <div className="fli1 col-md-4">
                  <div className="fli1-m">
                    <div className="fli1-m-l">
                      <img
                        src={airlineLogos[flight.AirlineName]}
                        alt={flight?.FlightName}
                      />
                    </div>
                    <div className="fli1-m-r">
                      <span className="ng-binding">{flight.FlightName}</span>
                      <span className="ng-binding">
                        {flight.CarrierCode} - {flight.FlightNumber}
                      </span>
                    </div>
                  </div>

                  <span className="fretype ng-binding ng-scope">
                    Retail Fare
                  </span>
                </div>

                <div className="fli-d-r col-md-8">
                  <div className="row">
                    <div className="fli2 col-md-4">
                      <div className="fli-cm">
                        <span>
                          <strong className="ng-binding">
                            {flight.DepartureTime}
                          </strong>
                        </span>
                      </div>
                      <div className="air-dt">
                        <div className="flc600">
                          <span className="ng-binding">{flight.Origin}</span>(
                          <span className="ng-binding">{flight.Origin}</span>)
                        </div>
                        <span className="ng-binding">
                          {new Date(flight.DepartureDate).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </span>

                        <span className="ng-binding ng-scope">
                          Terminal - {flight.DepartureTerminal}
                        </span>
                      </div>
                    </div>
                    <div className="fli3 col-md-4 ">
                      <div className="stp">
                        <span className="ng-binding">{flight.Duration}</span>{" "}
                      </div>
                      <div className="lin2 lindvd">
                        <div className="fli-i" />
                      </div>

                      <div className="refund">
                        <div className="refund-text text-center">
                          <Badge
                            borderColor={refundable ? "#2dca1c" : "#d21404"}
                            text={refundable ? "Refundable" : "Non-Refundable"}
                            textColor={refundable ? "#2dca1c" : "#d21404"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="fli4 col-md-4 ">
                      <div className="fli-cm1">
                        <span>
                          <strong className="ng-binding">
                            {flight.ArrivalTime}
                          </strong>
                        </span>
                      </div>

                      <div className="air-dt air-dt1">
                        <div className="flc600">
                          <span className="ng-binding">
                            {flight.Destination}
                          </span>
                          (
                          <span className="ng-binding">
                            {flight.Destination}
                          </span>
                          )
                        </div>
                        <span className="ng-binding">
                          {new Date(flight.ArrivalDate).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </span>

                        <span className="ng-binding ng-scope">
                          Terminal - {flight.ArrivalTerminal}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {flightData.length - 1 !== index && (
                <div className="layover ng-scope">
                  <span>
                    <strong className="ng-binding">
                      {flight.LayoverDuration}
                    </strong>
                    Layover in
                    <strong className="ng-binding"> {flight.LayoverAt}</strong>
                  </span>
                </div>
              )}
            </div>
          ))}

          <div>
            <div className="fli-amenities">
              {/* <div className="text-right">
                  {" "}
                  <a className="showmore Plu">(+) SHOW MORE</a>
                </div> */}

              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab label="Fare Rules" value={0} />
                    <Tab label="Baggage" value={1} />
                    {isInternationalFlight && (
                      <Tab label="Visa Info" value={2} />
                    )}
                  </Tabs>
                </Box>

                <CustomTabPanel value={value} index={0}>
                  <div className="card card-grid h-full min-w-full">
                    <div className="card-header">
                      <h3 className="card-title">Fare Rules</h3>
                    </div>
                    <div className="card-body">
                      <div
                        data-datatable="true"
                        data-datatable-page-size={5}
                        className="datatable-initialized"
                      >
                        <div style={{ overflowX: "auto", width: "100%" }}>
                          <table
                            className="table table-border pt-2"
                            data-datatable-table="true"
                          >
                            <thead>
                              <tr>
                                <th className="min-w-[400px]">
                                  <span className="sort asc">
                                    <span className="sort-label">
                                      Time Frame To Cancel
                                    </span>
                                  </span>
                                </th>
                                <th className="min-w-[100px]">
                                  <span className="sort">
                                    <span className="sort-label">
                                      Airline Fees
                                    </span>
                                  </span>
                                </th>
                                <th className="min-w-[100px]">
                                  <span className="sort">
                                    <span className="sort-label">
                                      EWTS Fees
                                    </span>
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dynamicFareRules.map(
                                ({ start, end, cancelFee }) => (
                                  <tr key={`cancel-${start}-${end}`}>
                                    <td>
                                      Cancel before {end} hours of departure
                                    </td>
                                    <td>
                                      <div className="flex flex-col gap-2">
                                        <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                          {currency} {cancelFee ?? 0}
                                        </a>
                                      </div>
                                    </td>
                                    <td>
                                      <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                        {currency} {emtFee}
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        data-datatable="true"
                        data-datatable-page-size={5}
                        className="datatable-initialized"
                      >
                        <div style={{ overflowX: "auto", width: "100%" }}>
                          <table
                            className="table table-border pt-2"
                            data-datatable-table="true"
                          >
                            <thead>
                              <tr>
                                <th style={{ width: "540px" }}>
                                  <span className="sort asc">
                                    <p className="sort-label">
                                      Time Frame To Reschedule
                                    </p>
                                  </span>
                                </th>
                                <th>
                                  <span className="sort">
                                    <span className="sort-label">
                                      Airline Fees
                                    </span>
                                  </span>
                                </th>
                                <th>
                                  <span className="sort">
                                    <span className="sort-label">
                                      EWTS Fees
                                    </span>
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dynamicFareRules.map(
                                ({ start, end, changeFee }) => (
                                  <tr key={`change-${start}-${end}`}>
                                    <td>
                                      Reschedule before {end} hours of departure
                                    </td>
                                    <td>
                                      <div className="flex flex-col gap-2">
                                        <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                          {currency} {changeFee ?? 0}
                                        </a>
                                      </div>
                                    </td>
                                    <td>
                                      <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                        {currency} {emtFee}
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12 terms-h ms-4 mb-2">
                          Terms &amp; Conditions
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="terms mar10">
                            <ul>
                              <li className="ng-binding">
                                Total Rescheduling Charges Airlines Rescheduling
                                fees Fare Difference if applicable + EWTS Fees.
                              </li>
                              <li>
                                The airline cancel reschedule fees is indicative
                                and can be changed without any prior notice by
                                the airlines..
                              </li>
                              <li>
                                EaseMyTrip does not guarantee the accuracy of
                                cancel reschedule fees.
                              </li>
                              <li>
                                Partial cancellation is not allowed on the
                                flight tickets which are book under special
                                round trip discounted fares.
                              </li>
                              <li>
                                Airlines doesnt allow any additional baggage
                                allowance for any infant added in the booking
                              </li>
                              <li>
                                In certain situations of restricted cases, no
                                amendments and cancellation is allowed
                              </li>
                              <li>
                                Airlines cancel reschedule should be reconfirmed
                                before requesting for a cancellation or
                                amendment
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                  <div className="accordion col-lg-12" id="accordionExample">
                    <div id="collapseTwo">
                      <div className="baggagerule mgt15 mar-to-12">
                        <div style={{ overflowX: "auto", width: "100%" }}>
                          <table width="100%" rules="all" border={1}>
                            <tbody>
                              <tr>
                                <th>
                                  <p className="frtbl_hd">Airline</p>
                                </th>
                                <th>
                                  <p className="frtbl_hd">Check-in Baggage</p>
                                </th>
                                <th>
                                  <p className="frtbl_hd">Cabin Baggage</p>
                                </th>
                              </tr>
                              {flightData?.map((flight: any, index: number) => (
                                <tr
                                  ng-repeat="baggage in BaggageModel"
                                  className="ng-scope"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="flgi-l"
                                      style={{
                                        float: "left",
                                        width: 32,
                                        marginRight: 10,
                                      }}
                                    >
                                      <img
                                        src={airlineLogos[flight?.AirlineName]}
                                        alt={flight?.FlightName}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        float: "left",
                                        fontSize: 11,
                                      }}
                                    >
                                      <p
                                        ng-bind="baggage.segDTL | split:'|':0"
                                        className="ng-binding"
                                      >
                                        {flight.FlightName}
                                      </p>
                                      <p className="ng-binding">
                                        {flight.CarrierCode}
                                        {"-"} {flight.FlightNumber}
                                      </p>
                                    </div>
                                  </td>
                                  <td className="ng-binding">
                                    {flight.BaggageWeight}kgs
                                  </td>

                                  <td className="ng-binding ng-scope">
                                    {flight.CabinBagWT}kg
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={2}>
                  <div className="card card-grid h-full min-w-full pt-3">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="terms mar10">
                          <ul>
                            <li className="ng-binding">
                              Please make sure that you have all relevant visa,
                              transit visa (if applicable), immigration
                              clearance and passport with a validity of minimum
                              6 months from the date of travel.
                            </li>
                            <li>
                              All visa rules on our website are just indicative
                              & are updated with best of our efforts. Please
                              refer official website of the respective country
                              to explore the complete and accurate requirements.
                              EaseMyTrip will not be liable for any claims about
                              non-travel because of the lack of any document
                            </li>
                            <li>For more visa details visit here</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </CustomTabPanel>
              </Box>
            </div>
          </div>
          <span></span>
        </div>
      </div>
    </>
  );
};

export default FlightDetailMainCard;
